import { Protocol } from '../Protocol';

export class CustomStandardV2Protocol {
  public static readonly SEARCH_CUSTOM_STANDARD_V2_SPECIFICATION_DETAILS: string = `${Protocol.YATUNG_API_ROOT}/standardV2/custom/specification/detail/search`;
}
